import React, { Component } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import SegmentPath from 'components/Map/MapComponents/SegmentPath';
import SegmentTooltip from 'components/Map/MapComponents/SegmentTooltip';
import segmentStatus from 'propTypes/segmentStatus';
import coord from 'propTypes/coord';

export default class Segment extends Component {
  static propTypes = {
    onSelect: func.isRequired,
    onEnter: func.isRequired,
    onLeave: func.isRequired,
    isActive: bool.isRequired,
    priority: number,
    segment: shape({
      id: string,
      path: arrayOf(coord),
      liveTravelTime: number.isRequired,
      status: segmentStatus.isRequired,
    }).isRequired,
  };

  defaultProps = {
    priority: 0,
  };

  state = {
    speedTrend: null,
  };

  componentWillReceiveProps(nextProps) {
    const trend =
      nextProps.segment.liveTravelTime >= this.props.segment.liveTravelTime ? 'up' : 'down';
    this.setState({ speedTrend: trend });
  }

  render() {
    // eslint-disable-next-line global-require
    const PriorityFeatureGroup = require('components/Map/MapComponents/PriorityFeatureGroup')
      .default;

    const { segment, onEnter, onLeave, onSelect, isActive } = this.props;
    const {
      id,
      from: { name: fromName },
      to: { name: toName },
      path,
      liveTravelTime,
      status,
    } = segment;
    const name = { from: fromName, to: toName };

    return (
      <PriorityFeatureGroup
        key={`Segment-${id}-${status}${isActive ? '-active' : ''}`}
        onMouseover={onEnter}
        onMouseout={onLeave}
        onClick={onSelect}
        priority={this.props.priority}
      >
        <SegmentPath latLngList={path} status={status} isActive={isActive} />
        <SegmentTooltip
          status={status}
          name={name}
          liveTravelTime={liveTravelTime}
          speedTrend={this.state.speedTrend}
        />
      </PriorityFeatureGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/Segment/index.js